import React, { Fragment, useEffect, useState } from "react";
import Header from "../Components/Header/Header";
import HeaderTitle from "../Components/HeaderTitle/HeaderTitle";
import DataTable from "../Components/DataTable/DataTable";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Components/Loading/Loading";
import NoData from "../Components/Loading/NoData";
import secureLocalStorage from "react-secure-storage";
import SideBar from "../Components/SideBar/SideBar";
import MetaData from "../Components/Helmet/Helmet";
import {
  clearInventoryDetails,
  getBatchesActions,
  HourlyProductionReportActions,
  ProductLevelConsolidatedReportActions,
} from "../Actions/ProductionActions";
import ModalContainer from "../Components/ModalContainer/ModalContainer";
import { Button } from "@material-ui/core";
import Dropdown from "../Components/Dropdown/Dropdown";
import { toast } from "react-toastify";
import PaginationRow from "../Components/Pagination/PaginationRow";
import DatePicker from "react-datepicker";
import { filterById } from "../Middleware/CommonFun";
import { CRITICAL_ARR } from "./ProductConsolidatedReport";
import moment from "moment";

export const TAB_ARR = [
  "Overall",
  <>
    Product Group <br />
    Wise
  </>,
  "SKU WISE",
  <>
    Style Color <br />
    Wise
  </>,
];

const HourlyProductionReport = () => {
  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;
  const dispatch = useDispatch();

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentpage, setCurrentPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(0);

  // User Profile State
  const { user_profile } = useSelector((state) => state.userProfile);

  // Product Level Consolidated Report State
  const { hourlyProductionRep, loading } = useSelector(
    (state) => state.HourlyProductionReport
  );

  const [isActiveTab, setIsActiveTab] = useState(1);

  const [isOpened, setIsOpened] = useState(false);

  const handleSidebar = () => {
    setIsOpened(!isOpened);
  };

  const handleRefreshBeforeLogout = () => {
    dispatch(clearInventoryDetails());
  };

  console.log(
    "PRODUCT LEVEL CONSOLIDATED REPORT: ",
    hourlyProductionRep?.data?.data
  );

  const [activeProduct, setActiveProduct] = useState("Product Group");
  const [activeProductListening, setActiveProductListening] =
    useState("product_group");

  // Modal Code starts here
  const [isIndex, setIsIndex] = useState(null);

  const handleModal = (index, id) => {
    setIsIndex(index);
  };

  const closeModal = () => {
    setIsIndex(null);
  };

  const renderModal = () => {
    if (isIndex !== null) {
      return (
        <ModalContainer
          Isopen={true}
          index={isIndex}
          closeModal={closeModal}
          onData={closeModal}
        />
      );
    }
    return null;
  };
  // Modal Code ends here

  // const ProductConsolidatedHeader = [
  //   { value: "Operation Node" },
  //   {
  //     value: <>{activeProduct}</>,
  //   },
  //   { value: "Date" },
  //   ...Array.from({ length: 10 }, (_, index) => {
  //     const start = 9 + index;
  //     const end = start + 1;
  //     return {
  //       value: `${start} - ${end}`,
  //       id: `time_${start}_${end}`,
  //     };
  //   }),
  // ];

  const ProductConsolidatedHeader = [
    { value: "Operation Node" },
    { value: <>{activeProduct}</> },
    { value: "Date" },
    ...Array.from({ length: 24 }, (_, index) => {
      const start = index;
      const end = (index + 1) % 24; // wrap around to 0 after 23
      const formatHour = (h) => h.toString().padStart(2, "0");
      return {
        value: `${formatHour(start)} - ${formatHour(end)}`,
        id: `time_${formatHour(start)}_${formatHour(end)}`,
      };
    }),
  ];

  const [ProductList, setProductList] = useState([]);

  console.log("PRODUCT CONSOLIDATED REPORT: ", ProductConsolidatedHeader);

  useEffect(() => {
    if (hourlyProductionRep && hourlyProductionRep?.status === 1) {
      console.log("TOTAL: ", hourlyProductionRep?.data);
      const totalPages = Math.ceil(
        hourlyProductionRep?.data?.total_count / pagesize
      );
      let products = Object.entries(
        hourlyProductionRep?.list?.products || {}
      ).map(([key, value]) => ({
        value: key,
        label: value,
      }));
      setProductList(products);
      setTotalPage(totalPages);
    }
  }, [totalRecords, pagesize, hourlyProductionRep]);

  console.log("TOTAL PAGES: ", totalPage);

  // Filter Code
  // Batches State
  const { getBatches, loading: batchLoading } = useSelector(
    (state) => state.Batches
  );

  const [productGroupList, setProductGroupList] = useState([]);

  useEffect(() => {
    // dispatch(
    // getBatchesActions("get_batches", null, null, null, null, null, 1, token)
    dispatch(getBatchesActions("get_batches", null, 1, 10, token));
    // );
  }, [dispatch, token]);

  // useEffect(() => {
  //   if (getBatches && getBatches?.status === 1) {
  //     const totalPages = Math.ceil(getBatches?.total_count / pagesize);
  //     setTotalPage(totalPages);
  //     setTotalPage(getBatches?.total_count);

  //     let product_group = Object.entries(getBatches?.list?.product_groups).map(
  //       ([key, value]) => ({
  //         value: key,
  //         label: value,
  //       })
  //     );
  //     setProductGroupList(product_group);

  //     let products = Object.entries(getBatches?.list?.products).map(
  //       ([key, value]) => ({
  //         value: key,
  //         label: value,
  //       })
  //     );
  //     setProductList(products);
  //   }
  // }, [getBatches]);

  useEffect(() => {
    if (getBatches && getBatches?.status === 1) {
      // const totalPages = Math.ceil(getBatches?.total_count / pagesize);
      // setTotalPage(totalPages);
      // setTotalPage(getBatches?.total_count);

      let product_group = Object.entries(
        getBatches?.list?.product_groups || {}
      ).map(([key, value]) => ({
        value: key,
        label: value,
      }));
      setProductGroupList(product_group);
    }
  }, [getBatches]);

  const [date, setDate] = useState(null);
  const [product_group_id, setProductGroupId] = useState("");
  const [product_id, setProduct_id] = useState("");
  const [show_critical_node_only, setShowCriticalNodeOnly] = useState("");

  const handleDate = (val) => {
    setDate(val);
  };

  const handleProductGroup = (val) => {
    setProductGroupId(val?.value);
  };

  const handleProduct = (val) => {
    setProduct_id(val?.value);
  };

  const handleNode = (val) => {
    console.log("VAL: ", val);
    setShowCriticalNodeOnly(val?.id);
  };

  const handleClearFilter = () => {
    setCurrentPage(1);
    setShowCriticalNodeOnly("");
    setProductGroupId("");
    setProduct_id("");
    setDate(null);
  };

  useEffect(() => {
    dispatch(
      HourlyProductionReportActions(
        "product_level_consolidated_hourly_report",
        token,
        activeProductListening,
        currentpage,
        pagesize,
        product_group_id,
        product_id,
        date ? moment(date).format("YYYY-MM-DD") : "",
        show_critical_node_only
      )
    );
  }, [
    dispatch,
    token,
    currentpage,
    pagesize,
    product_group_id,
    product_id,
    date,
    show_critical_node_only,
    activeProductListening,
  ]);

  const handleTabChange = (i) => {
    setCurrentPage(1);
    setShowCriticalNodeOnly("");
    setProductGroupId("");
    setProduct_id("");
    setDate(null);
    // console.log("I VAKYE: ", i);
    let idx =
      i === 1
        ? "product_group"
        : i === 2
        ? "product"
        : i === 3
        ? "category_style_color"
        : i === 0
        ? "overall"
        : null;

    let activeProduct =
      i === 1
        ? "Product Group"
        : i === 2
        ? "Product"
        : i === 3
        ? "Category Style Color"
        : i === 0
        ? "Overall"
        : null;
    setActiveProduct(activeProduct);
    setActiveProductListening(idx);
    if (idx === null) {
      toast.error("Something Went Wrong");
      return;
    }
    setIsActiveTab(i);
    dispatch(
      ProductLevelConsolidatedReportActions(
        "product_level_consolidated_hourly_report",
        token,
        idx
      )
    );
  };

  return (
    <Fragment>
      <MetaData title={`Hourly Production Report`} />

      <SideBar isOpened={isOpened} handleSidebar={handleSidebar} />

      {/* Header Component starts here */}
      <Header
        handleRefreshBeforeLogout={handleRefreshBeforeLogout}
        profile_image={user_profile && user_profile?.data?.profile_image}
        handleSidebar={handleSidebar}
      />
      {/* Header Component starts here */}

      {/* SideBar component starts here */}
      {/* SideBar component ends here */}
      <div className="gantt-chart-wrapper-container">
        {/* Heading Component starts here */}
        <HeaderTitle link={false} title={"Hourly Production Report"} />
        <div className="container">
          {/* Tab Module Component starts here */}
          <div className="product__level_grid_row">
            {TAB_ARR &&
              TAB_ARR?.map((i, index) => (
                <div key={index}>
                  <Button
                    className={`${
                      isActiveTab === index ? "active__botsTab" : ""
                    }`}
                    onClick={() => handleTabChange(index)}
                  >
                    {i}
                  </Button>
                </div>
              ))}
          </div>
          {/* Tab Module Component ends here */}

          {/* Dropdown Component starts here */}
          <div className="dropdown__grid__row mobile__grid__dropd__row">
            <div>
              <Dropdown
                label="Product Group"
                placeholder="Product Group"
                dropdown={productGroupList}
                onData={(val) => handleProductGroup(val)}
                value={filterById(productGroupList, product_group_id)}
              />
            </div>
            <div>
              <Dropdown
                label="Product"
                placeholder="Product"
                dropdown={ProductList}
                onData={(val) => handleProduct(val)}
                value={filterById(ProductList, product_id)}
              />
            </div>
            <div>
              <Dropdown
                label="Critical Mode"
                placeholder="Critical Mode"
                dropdown={CRITICAL_ARR}
                onData={(val) => handleNode(val)}
                value={filterById(CRITICAL_ARR, show_critical_node_only)}
              />
            </div>
            <div>
              <label htmlFor="" className="label">
                Date
              </label>
              <DatePicker
                className="date-picker"
                selected={date}
                placeholderText="Date"
                onChange={(date) => handleDate(date)}
              />
            </div>
            <div className="clear__filter">
              <Button onClick={handleClearFilter}>Clear Filter</Button>
            </div>
          </div>
          {/* Dropdown Component ends here */}

          {/* 30/70 grid container row starts here */}
          <div>
            {/* left row container */}
            {/* Table container starts here */}
            <div className="production-container manufacturing-container">
              <div className="table-wrapper-pagination product-consolidated-report">
                <div className="table-container-pagination">
                  {loading ? (
                    <Loading
                      loading={loading}
                      color={"rgba(1, 18, 34, 1)"}
                      size={42}
                    />
                  ) : (
                    <>
                      {hourlyProductionRep &&
                      hourlyProductionRep?.data?.data?.length > 0 ? (
                        <DataTable
                          items_per_page={10}
                          page={1}
                          header={ProductConsolidatedHeader}
                          hourlyConsolidatedReport={
                            hourlyProductionRep?.data?.data || []
                          }
                          activeProduct={activeProduct}
                        />
                      ) : (
                        <NoData title={"No Results Found"} />
                      )}
                    </>
                  )}
                </div>

                <PaginationRow
                  totalRecords={totalRecords}
                  uniqueKey={`product_Consolidated-${currentpage}`}
                  currentpage={currentpage}
                  setCurrentPage={setCurrentPage}
                  totalPage={totalPage}
                  pagesize={pagesize}
                  setPageSize={setPageSize}
                />
              </div>
            </div>
            {/* Table container ends here */}
            {/* right row container */}
          </div>
          {/* 30/70 grid container row ends here */}
        </div>
      </div>
      {renderModal()}
    </Fragment>
  );
};

export default HourlyProductionReport;
